import type NativeAd from './schema/NativeAd';
import type NativeAdStore from './schema/NativeAdStore';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

export const messageAdStore = createStore<NativeAdStore>('messageAdStore', {
    adIds: [],
    nativeAdRowStore: new ObservableMap<string, NativeAd>({}),
})();

export const getStore = () => messageAdStore;
